import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "pos-leaderboard",
  class: "bg-gray-lp-1400 p-4 h-full flex flex-col gap-y-4"
}
const _hoisted_2 = { class: "rounded-3xl bg-white p-3 flex flex-col gap-y-4" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = {
  key: 1,
  class: "text-gray-lp-800 text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Summary = _resolveComponent("Summary")!
  const _component_CategoryLeaderboardFilter = _resolveComponent("CategoryLeaderboardFilter")!
  const _component_PosLeaderboardTable = _resolveComponent("PosLeaderboardTable")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Summary, {
      modelValue: _ctx.summaryData,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.summaryData = $event)),
      loading: _ctx.loadingSummary,
      onFilter: _ctx.getFilter
    }, null, 8, ["modelValue", "loading", "onFilter"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.categoryOptions.length)
          ? (_openBlock(), _createBlock(_component_CategoryLeaderboardFilter, {
              key: 0,
              modelValue: _ctx.category,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => (_ctx.category = $event)),
                _ctx.getConfig
              ],
              options: _ctx.categoryOptions
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : _createCommentVNode("", true),
        (_ctx.summaryData.lastUpdatedAt)
          ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('dashboard.leaderboard.updated')) + " " + _toDisplayString(_ctx.formatDateToString(_ctx.summaryData.lastUpdatedAt)), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_PosLeaderboardTable, {
        period: _ctx.period,
        scope: _ctx.category.value,
        areaCode: _ctx.category.label,
        config: _ctx.config,
        error: _ctx.error,
        onRetry: _ctx.onRetry
      }, null, 8, ["period", "scope", "areaCode", "config", "error", "onRetry"])
    ])
  ]))
}